import { Collider } from './Collider';
import { Vector3, Vector4 } from '@math.gl/core';
import { Shader } from '../renderer/webgl/Shader';
import { fillVert } from '../../assets/shaders/fillVert';
import { fillFrag } from '../../assets/shaders/fillFrag';
import { Plane } from '../renderer/mesh/Plane';
import { GeometryTest } from '../utils/GeometryTest';
/**
 * 2Dの当たり判定
 * 主にMultiViewのタッチ判定など
 */
export class Box2dCollider extends Collider {
    static Rect = [
        new Vector3(-0.5, 0.5, 0),
        new Vector3(0.5, 0.5, 0),
        new Vector3(-0.5, -0.5, 0),
        new Vector3(0.5, -0.5, 0),
    ];
    width = 1;
    height = 1;
    showHitRect = false;
    showHitRectColor = new Vector4(1, 0, 0, 0.5);
    _shader;
    test(ray) {
        const matrix = this.node.matrixWorld.clone().scale([this.width, this.height, 1]);
        // 2dのレイキャストのみを考慮
        const p = Box2dCollider.Rect.map(p => {
            const out = new Vector3();
            matrix.transform(p, out);
            return out;
        });
        const triangles = [
            [p[2], p[0], p[1]],
            [p[1], p[3], p[2]],
        ];
        let t = Number.MAX_SAFE_INTEGER;
        for (let i = 0; i < triangles.length; i++) {
            const triangle = triangles[i];
            t = Math.min(t, GeometryTest.rayTriangleIntersect(ray, 10, triangle[0], triangle[1], triangle[2]));
        }
        if (t <= 10) {
            return {
                collider: this,
                distance: t,
                point: ray.origin.clone().add(ray.direction.clone().multiplyScalar(t)),
                node: this.node
            };
        }
        return null;
    }
    /**
     * showHitRectがtrueだったらデバッグ表示する
     * @param gl
     * @param pMatrix
     */
    onDraw(gl, pMatrix) {
        if (!this.showHitRect) {
            return;
        }
        if (!this._shader) {
            this._shader = new Shader(gl, 'fill');
            this._shader.compile(fillVert, fillFrag);
        }
        this._shader.activate();
        const mvp = pMatrix.clone().multiplyRight(this.node.matrixWorld.clone().scale([this.width, this.height, 1]));
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        gl.uniformMatrix4fv(this._shader.getUniform('MATRIX_MVP'), false, mvp);
        gl.uniform4fv(this._shader.getUniform('FillColor'), this.showHitRectColor);
        Plane.sharedPlane(gl).draw(this._shader);
    }
}
//# sourceMappingURL=Box2dCollider.js.map